import { Injectable, OnDestroy } from '@angular/core';

@Injectable()
export class AppTimerService implements OnDestroy {
  private timers: Record<string, any> = {};
  private intervals: Record<string, any> = {};

  // Timeout için metotlar
  public setTimer(name: string, fn: () => void, delay: number): void {
    this.clearTimer(name); // Mevcut timer varsa iptal et
    this.timers[name] = setTimeout(fn, delay);
  }

  public clearTimer(name: string): void {
    if (this.timers[name]) {
      clearTimeout(this.timers[name]);
      delete this.timers[name];
    }
  }

  // Interval için metotlar
  public setInterval(name: string, fn: () => void, interval: number): void {
    this.clearInterval(name); // Mevcut interval varsa iptal et
    this.intervals[name] = setInterval(fn, interval);
  }

  public clearInterval(name: string): void {
    if (this.intervals[name]) {
      clearInterval(this.intervals[name]);
      delete this.intervals[name];
    }
  }

  // OnDestroy metotlarını genişletme
  ngOnDestroy() {
    this.clearAllTimers();
    this.clearAllIntervals();
  }

  // Tüm timer'ları iptal etme
  private clearAllTimers(): void {
    for (const name of Object.keys(this.timers)) {
      clearTimeout(this.timers[name]);
      delete this.timers[name];
    }
  }

  // Tüm interval'ları iptal etme
  private clearAllIntervals(): void {
    for (const name of Object.keys(this.intervals)) {
      clearInterval(this.intervals[name]);
      delete this.intervals[name];
    }
  }
}
